import { Service } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SymbolMessage } from '../models/symbol-message.model';
import { BaseService } from './base.service';

@Service()
export class MessagesService extends BaseService {
	/**
	 * Supervisor and general messages for one symbol, newest first.
	 *
	 * TODO: the endpoint isn't available on the backend yet, so this answers with an empty feed.
	 * Once it is, this is the only place that has to change:
	 *
	 * ```ts
	 * return this.http
	 *   .get<SymbolMessagesResponse>(`${this.kalaApiPath}/messages/symbol`, {
	 *     params: new HttpParams().set('isin', symbolIsin)
	 *   })
	 *   .pipe(map(response => (response.Data?.list ?? []).map(mapSymbolMessage)));
	 * ```
	 */
	// eslint-disable-next-line @typescript-eslint/no-unused-vars -- kept so callers don't change once the endpoint lands
	getSymbolMessages(symbolIsin: string): Observable<SymbolMessage[]> {
		return of<SymbolMessage[]>([]);
	}
}
